import { useState } from "react";
import FloatingInput from "./FloatingInput";
import { Button, useMatches } from "@mantine/core";
import { IconArrowRight, IconTopologyStar3 } from "@tabler/icons-react";
import { validateForm } from "./Validation";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import toast from "react-hot-toast";
import emailjs from "emailjs-com"; 

const Contact = () => {
  const toastStyles = {
    backgroundColor: "#0A0A0A",
    color: "#8892B0",
    border: "1px solid #64FFDA",
    padding: "10px",
    borderRadius: "5px",
  };

  const form = {
    name: "",
    email: "",
    phone: "",
    message: "",
  };

  const [formData, setFormData] = useState<{ [key: string]: string }>(form);
  const [formError, setFormError] = useState<{ [key: string]: string }>(form);

  const handleChange = (id: string, value: string) => {
    setFormData({ ...formData, [id]: value });
    setFormError({ ...formError, [id]: validateForm(id, value) });
  };

  const sendEmail = (formData: any) => {
    const currentTime = new Date().toLocaleString(); // Get timestamp

    emailjs.send(
      "service_dqlozxr", 
      "template_irtc4uf", 
      {
        user_name: formData.name,
        user_email: formData.email,
        message: formData.message,
        phone: formData.phone,
        time_stamp: currentTime, 
      },
      "JZN8-2c7ZwSZ-m0DT" 
    )
    .then(
      (result) => {
        console.log(result.text);
        toast.success("Email sent successfully!", { style: toastStyles });
      },
      (error) => {
        console.error("Failed to send email: ", error.text);
        toast.error("Failed to send email.", { style: toastStyles });
      }
    );
  };

  const handleSubmit = async () => {
    let valid = true;
    let newFormError: { [key: string]: string } = {};

    for (let key in formData) {
      const error = validateForm(key, formData[key]);
      if (error.length > 0) {
        newFormError[key] = error;
        valid = false;
      }
    }

    setFormError(newFormError);

    if (valid) {
      try {
        await addDoc(collection(db, "contacts"), {
          ...formData,
          timestamp: serverTimestamp(),
        });

        // Reset form
        setFormData(form);

        // Send email
        sendEmail(formData);

        toast.success("Form Submitted Successfully!", {
          style: toastStyles,
        });
      } catch (error) {
        console.error("Error adding document: ", error);
        toast.error("Failed to submit the form. Please try again.", {
          style: toastStyles,
        });
      }
    } else {
      toast.error("Please fix the errors in the form.", {
        style: toastStyles,
      });
    }
  };

  const btn = useMatches({
    xsm: "xs",
    sm: "sm",
    md: "md",
    lg: "lg",
  });

  return (
    <div className="px-16 md-mx:px-8 sm-mx:px-4 mx-20 lg-mx:mx-10 md-mx:mx-0 my-10 font-mono" id="Contact">
      <h1 className="text-4xl sm-mx:text-3xl xs-mx:text-2xl mb-10 font-bold text-center text-white">
        <span className="text-primaryColor">05.&nbsp;</span>Contact
      </h1>
      <div 
        data-aos="flip-left" 
        data-aos-duration="800" 
        className="w-[70%] lg-mx:w-full shadow-[0_0_10px_0_#64FFDA50] m-auto flex flex-col gap-6 border border-primaryColor p-8 rounded-3xl sm-mx:p-4"
      >
        <div className="text-3xl flex gap-2 items-center text-white font-semibold sm-mx:text-2xl xs-mx:text-xl" data-aos="fade-up" data-aos-duration="800">
          Let's Connect
          <IconTopologyStar3 className="w-10 text-primaryColor h-10 sm-mx:w-7 sm-mx:h-7" />
        </div>
        <FloatingInput id="name" name="Name" value={formData.name} handleChange={handleChange} error={formError.name} />
        <FloatingInput id="email" name="Email" value={formData.email} handleChange={handleChange} error={formError.email} />
        <FloatingInput id="phone" name="Phone Number" value={formData.phone} handleChange={handleChange} error={formError.phone} />
        <FloatingInput id="message" name="Message" value={formData.message} handleChange={handleChange} error={formError.message} />
        <Button 
          fullWidth 
          onClick={handleSubmit} 
          rightSection={<IconArrowRight size={20} />}
          className="!text-bgColor !font-bold" 
          variant="filled" 
          size={btn} 
          radius="lg" 
          color="#64FFDA" 
          data-aos="fade-up" 
          data-aos-duration="800"
        >
          Send
        </Button>
      </div>
    </div>
  );
};

export default Contact;
